<div class="section default">
        <div class="theme-container">
            <h1 class="section-title">Our Mission</h1>            
            <mat-card appearance="outlined">
                <mat-card-content>
                    <div class="flex-row flex-wrap">
                        <div class="flex-gt-xs-50 flex-xs-100">
                            <mat-icon color="primary" class="mat-icon-xlg">monetization_on</mat-icon>
                            <h2 class="capitalize fw-600 my-2">save money</h2>
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Vitae dolor magnam, facilis voluptas quia excepturi provident cupiditate.</p>
                        </div>
                        <div class="flex-gt-xs-50 flex-xs-100">
                            <mat-icon color="primary" class="mat-icon-xlg">thumb_up</mat-icon>
                            <h2 class="capitalize fw-600 my-2">better ideas</h2>
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Vitae dolor magnam, facilis voluptas quia excepturi provident cupiditate.</p>
                        </div>
                        <div class="flex-gt-xs-50 flex-xs-100">
                            <mat-icon color="primary" class="mat-icon-xlg">group</mat-icon>
                            <h2 class="capitalize fw-600 my-2">collaboration</h2>
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Vitae dolor magnam, facilis voluptas quia excepturi provident cupiditate.</p>
                        </div>
                        <div class="flex-gt-xs-50 flex-xs-100">
                            <mat-icon color="primary" class="mat-icon-xlg">search</mat-icon>
                            <h2 class="capitalize fw-600 my-2">easy to find</h2>
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Vitae dolor magnam, facilis voluptas quia excepturi provident cupiditate.</p>
                        </div>
                    </div>                  
                </mat-card-content>     
            </mat-card>
        </div>
 
</div>